import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  CircularProgress,
  IconButton,
  InputAdornment,
  OutlinedInput,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  Checkbox,
  Box,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { createAbility, updateAbility } from "../../../config/acl/ability";

export const FormEditProfile = ({ data, managers, setData }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [image, setImage] = useState(data?.photo);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const previewUrl = URL.createObjectURL(files[0]);
      setImage(previewUrl);
      setData((prev) => ({
        ...prev,
        photo: files[0],
      }));
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (errorMessage && name === "password") {
        if (value === data.password_confirmation) setErrorMessage();
      }
      if (errorMessage && name === "password_confirmation") {
        if (value === data.password) setErrorMessage();
      }
    }
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleManagerChange = (e) => {
    setData((prev) => ({
      ...prev,
      manager_id: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (data.password !== data.password_confirmation) {
      setErrorMessage(
          "Passwords do not match! Please ensure both passwords are the same."
      );
      return;
    }

    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    for (let key in data) {
      if (key === "photo") {
        if (data.photo && typeof data.photo !== "string") {
          formDataToSend.append("photo", data.photo);
        }
      } else if (key === "permissions") {
        data.permissions.forEach((permissionId) => {
          formDataToSend.append("permissions[]", permissionId);
        });
      } else if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.Profile.Edit,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Profile");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
      <form onSubmit={handleSubmit}>
        {/* Name, Email, Role, and Password inputs */}
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
          <TextField
              fullWidth
              margin="normal"
              label="Name"
              name="name"
              required
              autoComplete="off"
              value={data.name}
              onChange={handleInputChange}
              variant="outlined"
          />
          <TextField
              fullWidth
              margin="normal"
              label="Email"
              name="email"
              required
              type="email"
              autoComplete="off"
              value={data.email}
              onChange={handleInputChange}
              variant="outlined"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-1 items-center gap-4">
          <div className="flex gap-4 items-center">
            {image && (
                <div className="flex items-center flex-col w-14 h-18">
                  <div className="img-container w-14 h-14 rounded-full overflow-hidden border">
                    <img
                        src={image}
                        alt="Current Upload"
                        className="w-14 h-14 object-cover"
                    />
                  </div>
                  <div className="whitespace-nowrap font-extralight text-xs">
                    Current image
                  </div>
                </div>
            )}
            <TextField
                className="w-[calc(100%-3.5rem)]"
                margin="normal"
                label="Upload Image to change"
                name="file"
                type="file"
                InputLabelProps={{ shrink: true }}
                onChange={handleInputChange}
                variant="outlined"
                inputProps={{
                  accept: "image/*",
                }}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
          <div className="mt-3 mb-3">
            <FormControl className="w-full mt-4 mb-2" variant="outlined">
              <InputLabel htmlFor="outlined-adornment-password">
                Password
              </InputLabel>
              <OutlinedInput
                  fullWidth
                  id="outlined-adornment-password"
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                          aria-label={
                            showPassword
                                ? "hide the password"
                                : "display the password"
                          }
                          onClick={handleClickShowPassword}
                          edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                  name="password"
                  autoComplete="off"
                  value={data.password}
                  onChange={handleInputChange}
                  variant="outlined"
              />
            </FormControl>
          </div>

          <div className="mt-4 mb-3">
            <FormControl className="w-full" variant="outlined">
              <InputLabel htmlFor="outlined-adornment-confirm-password">
                Confirm password
              </InputLabel>
              <OutlinedInput
                  fullWidth
                  margin="normal"
                  id="outlined-adornment-confirm-password"
                  type={showPassword ? "text" : "password"}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                          aria-label={
                            showPassword
                                ? "hide the password"
                                : "display the password"
                          }
                          onClick={handleClickShowPassword}
                          edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Confirm password"
                  name="password_confirmation"
                  autoComplete="off"
                  value={data.password_confirmation}
                  onChange={handleInputChange}
                  variant="outlined"
              />
            </FormControl>
          </div>
        </div>
        {errorMessage && (
            <div className="w-full text-start text-red-600">*{errorMessage}</div>
        )}

        {/*/!* Active Radio Buttons *!/*/}
        {/*<div className="flex items-center justify-between gap-x-3">*/}
        {/*  <div className="flex items-center justify-start gap-x-3">*/}
        {/*    <FormLabel sx={{ fontWeight: "bold" }} component="legend">*/}
        {/*      Active:*/}
        {/*    </FormLabel>*/}
        {/*    <RadioGroup*/}
        {/*        name="active"*/}
        {/*        value={data.active}*/}
        {/*        onChange={handleRadioChange}*/}
        {/*        row*/}
        {/*    >*/}
        {/*      <FormControlLabel value="1" control={<Radio />} label="Yes" />*/}
        {/*      <FormControlLabel value="0" control={<Radio />} label="No" />*/}
        {/*    </RadioGroup>*/}
        {/*  </div>*/}
        {/*</div>*/}

        {/* Permissions Checkboxes with Grid Layout */}
        {/*<div className="mt-4">*/}
        {/*  <FormLabel*/}
        {/*      sx={{ fontWeight: "bold", textAlign: "left", width: "100%" }}*/}
        {/*      component="legend"*/}
        {/*  >*/}
        {/*    Permissions:*/}
        {/*  </FormLabel>*/}
        {/*  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">*/}
        {/*    {permissions?.map((permission) => (*/}
        {/*        <FormControlLabel*/}
        {/*            key={permission.id}*/}
        {/*            control={*/}
        {/*              <Checkbox*/}
        {/*                  name="permissions[]"*/}
        {/*                  value={permission.id.toString()}*/}
        {/*                  checked={data.permissions.includes(permission.id.toString())}*/}
        {/*                  onChange={handlePermissionChange}*/}
        {/*              />*/}
        {/*            }*/}
        {/*            label={permission.name}*/}
        {/*        />*/}
        {/*    ))}*/}
        {/*  </div>*/}
        {/*</div>*/}

        <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={isLoadingSubmit || errorMessage}
            color="primary"
            sx={{
              display: isLoadingSubmit ? "flex" : "block",
              marginTop: 2,
              width: "20%",
              marginX: "auto",
              fontWeight: "bold",
              justifyContent: "center",
            }}
        >
          {isLoadingSubmit ? (
              <CircularProgress size={24} color="primary" />
          ) : (
              "Submit"
          )}
        </Button>
      </form>
  );
};